import { createSlice } from '@reduxjs/toolkit'
import { AxiosError } from '@src/helpers/httpClient'

import {
  CONFERENCE,
  CONFERENCE_ALL,
  CONFERENCE_ARTICLE_BY_ID,
  CONFERENCE_ARTICLE_ALL,
  CONFERENCE_ARTICLE_CREATE,
  CONFERENCE_CATEGORY_ALL,
  GLOBAL_STATE,
} from '../constants/actionTypes'
import * as actionCreators from './actions'
import { defaultState, initialState } from './initialState'

export const CONFERENCES = GLOBAL_STATE

export const { reducer: conferenceReducer } = createSlice({
  name: CONFERENCES,
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(actionCreators.conference.pending, state => {
        state[CONFERENCE].loading = true
      })
      .addCase(actionCreators.conference.rejected, (state, action) => {
        state[CONFERENCE].loading = false
        state[CONFERENCE].error = action.payload as AxiosError
      })
      .addCase(actionCreators.conference.fulfilled, (state, action) => {
        state[CONFERENCE].loading = false
        state[CONFERENCE].error = null
        state[CONFERENCE].data = action.payload
      })

    builder
      .addCase(actionCreators.conferenceArticle.pending, state => {
        state[CONFERENCE_ARTICLE_BY_ID].loading = true
      })
      .addCase(actionCreators.conferenceArticle.rejected, (state, action) => {
        state[CONFERENCE_ARTICLE_BY_ID].loading = false
        state[CONFERENCE_ARTICLE_BY_ID].error = action.payload as AxiosError
      })
      .addCase(actionCreators.conferenceArticle.fulfilled, (state, action) => {
        state[CONFERENCE_ARTICLE_BY_ID].loading = false
        state[CONFERENCE_ARTICLE_BY_ID].error = null
        state[CONFERENCE_ARTICLE_BY_ID].data = action.payload
      })

    builder
      .addCase(actionCreators.conferenceArticleCreate.pending, state => {
        state[CONFERENCE_ARTICLE_CREATE].loading = true
      })
      .addCase(actionCreators.conferenceArticleCreate.rejected, (state, action) => {
        state[CONFERENCE_ARTICLE_CREATE].loading = false
        state[CONFERENCE_ARTICLE_CREATE].error = action.payload as AxiosError
      })
      .addCase(actionCreators.conferenceArticleCreate.fulfilled, (state, action) => {
        state[CONFERENCE_ARTICLE_CREATE].loading = false
        state[CONFERENCE_ARTICLE_CREATE].error = null
        state[CONFERENCE_ARTICLE_CREATE].data = action.payload
      })

    builder
      .addCase(actionCreators.conferenceArticleAll.pending, state => {
        state[CONFERENCE_ARTICLE_ALL].loading = true
      })
      .addCase(actionCreators.conferenceArticleAll.rejected, (state, action) => {
        state[CONFERENCE_ARTICLE_ALL].loading = false
        state[CONFERENCE_ARTICLE_ALL].error = action.payload as AxiosError
      })
      .addCase(actionCreators.conferenceArticleAll.fulfilled, (state, action) => {
        state[CONFERENCE_ARTICLE_ALL].loading = false
        state[CONFERENCE_ARTICLE_ALL].error = null
        state[CONFERENCE_ARTICLE_ALL].data = action.payload
      })

    builder
      .addCase(actionCreators.conferenceCategoryAll.pending, state => {
        state[CONFERENCE_CATEGORY_ALL].loading = true
      })
      .addCase(actionCreators.conferenceCategoryAll.rejected, (state, action) => {
        state[CONFERENCE_CATEGORY_ALL].loading = false
        state[CONFERENCE_CATEGORY_ALL].error = action.payload as AxiosError
      })
      .addCase(actionCreators.conferenceCategoryAll.fulfilled, (state, action) => {
        state[CONFERENCE_CATEGORY_ALL].loading = false
        state[CONFERENCE_CATEGORY_ALL].error = null
        state[CONFERENCE_CATEGORY_ALL].data = action.payload
      })

    builder
      .addCase(actionCreators.conferenceAll.pending, state => {
        state[CONFERENCE_ALL].loading = true
      })
      .addCase(actionCreators.conferenceAll.rejected, (state, action) => {
        state[CONFERENCE_ALL].loading = false
        state[CONFERENCE_ALL].error = action.payload as AxiosError
      })
      .addCase(actionCreators.conferenceAll.fulfilled, (state, action) => {
        state[CONFERENCE_ALL].loading = false
        state[CONFERENCE_ALL].error = null
        state[CONFERENCE_ALL].data = action.payload
      })

    builder.addCase(actionCreators.conferenceClear, state => {
      state[CONFERENCE] = defaultState()
    })

    builder.addCase(actionCreators.conferenceArticleClear, state => {
      state[CONFERENCE_ARTICLE_BY_ID] = defaultState()
    })

    builder.addCase(actionCreators.conferenceArticleAllClear, state => {
      state[CONFERENCE_ARTICLE_ALL] = defaultState()
    })

    builder.addCase(actionCreators.conferenceCategoryAllClear, state => {
      state[CONFERENCE_CATEGORY_ALL] = defaultState()
    })

    builder.addCase(actionCreators.conferenceAllClear, state => {
      state[CONFERENCE_ALL] = defaultState()
    })
  },
})
